import React from 'react';
import './App.css';
import Calculator from './component/Calculator'
import Header from './semantics/header/Header'
import Footer from './semantics/footer/Footer'

function App() {
  return (
    <div className="App"> 
        <Header headLine = "Simple Calculator" />       
        <Calculator/>
        <Footer/>
    </div>
  );
}

export default App;
